import { type ReactNode } from "react";
import { clsx } from "clsx";

export type BadgeVariant = "default" | "success" | "warning" | "danger" | "info";

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: "bg-[#f1f5f9] text-[#64748b]",
  success: "bg-[#f0fdf4] text-[#16a34a]",
  warning: "bg-[#fffbeb] text-[#d97706]",
  danger: "bg-[#fef2f2] text-[#dc2626]",
  info: "bg-[#ecfeff] text-[#0891b2]",
};

export function Badge({ variant = "default", children, className }: BadgeProps) {
  return (
    <span
      className={clsx(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        variantClasses[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}

/**
 * Maps common status strings to badge variants.
 */
export function statusVariant(status: string): BadgeVariant {
  const lower = status.toLowerCase();
  if (["finalized", "approved", "active", "paid", "present", "done"].includes(lower))
    return "success";
  if (["pending", "draft", "in_progress", "todo"].includes(lower)) return "warning";
  if (["rejected", "blocked", "inactive", "absent"].includes(lower)) return "danger";
  if (["late", "on_leave"].includes(lower)) return "info";
  return "default";
}
